import { render } from "./CreatedEditImageView.vue?vue&type=template&id=3a106bd2&scoped=true"
import script from "./CreatedEditImageView.vue?vue&type=script&lang=js"
export * from "./CreatedEditImageView.vue?vue&type=script&lang=js"

import "./CreatedEditImageView.vue?vue&type=style&index=0&id=3a106bd2&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\StrinGent\\Desktop\\Robo-FullStack\\FrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a106bd2"]])

export default __exports__